export const apiEndpoint = 'https://code-droid-api.herokuapp.com/api';
export const socketEndpoint = 'https://code-droid-api.herokuapp.com';
